import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import WhyDangol from '../components/WhyDangol';
import { useScrollReveal } from '../utils/useScrollReveal';

const About = () => {
  useScrollReveal();
  return (
    <div className="App">
      <Header />
      <div style={{ paddingTop: 80 }}>
        <WhyDangol />
      </div>
      <Footer />
    </div>
  );
};

export default About;
